/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Features_Today_KickerInputs */

const en_features_today_kicker = /** @type {(inputs: Features_Today_KickerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} visits today`)
};

const pl_features_today_kicker = /** @type {(inputs: Features_Today_KickerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wizyty dziś`)
};

/**
* | output |
* | --- |
* | "{count} visits today" |
*
* @param {Features_Today_KickerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_today_kicker = /** @type {((inputs: Features_Today_KickerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Today_KickerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_today_kicker(inputs)
	return en_features_today_kicker(inputs)
});